export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    message: {
      type: null,
      default: undefined,
    },
    rules: {
      type: String,
      default: '',
    },
    value: {
      type: null,
      required: true,
    },
    vid: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      },
    },
  },
}
